
import { User, FileText } from "lucide-react";

interface DashboardSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const DashboardSidebar = ({ isOpen, onClose }: DashboardSidebarProps) => {
  return (
    <>
      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed left-0 top-0 h-full w-64 bg-gradient-to-br from-pink-50 via-white to-purple-50 border-r border-gray-200 p-6 transform transition-transform duration-300 ease-in-out z-50 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}>
        {/* Logo/Brand */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Mayl</h1>
        </div>

        {/* Navigation */}
        <nav className="space-y-2">
          <div className="flex items-center space-x-3 p-3 rounded-lg bg-gray-50 text-gray-900">
            <User className="w-5 h-5" />
            <span className="font-medium">User</span>
          </div>
          <div className="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <FileText className="w-5 h-5" />
            <span>Contracts</span>
          </div>
        </nav>
      </div>
    </>
  );
};

export default DashboardSidebar;
